// Shared constants — update model name here and it propagates everywhere
export const AI_MODEL = 'claude-sonnet-4-6';
export const APP_URL = typeof window !== 'undefined' ? window.location.origin : 'https://learnable.shortley.com';

// Stripe payment links — create each in Stripe Dashboard > Products > Payment Links
// Then replace the placeholder URLs with the real ones
export const STRIPE_SCHOLAR_MONTHLY = 'https://buy.stripe.com/fZu4gyfAC7N2fGdaDVb7y06';
export const STRIPE_SCHOLAR_ANNUAL  = 'https://buy.stripe.com/aFadR83RU7N29hPaDVb7y04';
export const STRIPE_PRO_MONTHLY     = 'https://buy.stripe.com/eVq28q746aZe3XvfYfb7y03';
export const STRIPE_PRO_ANNUAL      = 'https://buy.stripe.com/4gM9ASdsu3wM2Tr9zRb7y05';

export const STRIPE_DONATE = 'https://donate.stripe.com/28EeVcgEGebqgKhh2jb7y00';

// Stripe Customer Portal — configure at dashboard.stripe.com > Settings > Customer Portal
export const STRIPE_BILLING_PORTAL  = 'https://billing.stripe.com/p/login/REPLACE_PORTAL_ID';

// Free tier hard caps
export const FREE_CREDITS           = 30;
export const FREE_SUBJECTS_MAX      = 3;
export const FREE_NOTES_MAX         = 20;
export const FREE_DECKS_MAX         = 3;
export const FREE_RUSH_SESSION_MAX  = 5;
export const FREE_DIAGNOSTICS_MONTH = 1;

// Scholar tier soft caps
export const SCHOLAR_CREDITS        = 300;
export const SCHOLAR_PLANS_MONTH    = 3;
export const SCHOLAR_DIAGNOSTICS_MONTH = 5;
export const SCHOLAR_PREDICTED_MONTH   = 2;
